export default __webpack_public_path__ + "static/media/delivery-control-logo-512px.e2ad0e06.png";